import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { FleetService } from '../../../services/fleet/fleet.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MatSnackBar ,
  MatPaginator, MatTableDataSource,
  MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSlideToggleModule
} from '@angular/material';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-schedulefleet',
  templateUrl: './schedulefleet.component.html',
  styleUrls: ['./schedulefleet.component.scss']
})
export class SchedulefleetComponent implements OnInit {

  schedulefleetForm: FormGroup;
  //activity log
  vehicleNumberArray = [];
  fleetAddedBy: string;
  fleetCreationDate: string;
  fleetUpdationDate: string;
  displayedColumns: string[] = ['fleetLicenseNumber', 'startDateTime', 'endDateTime', 'unavailabilityReason'];
  
  scheduleDataSource = new MatTableDataSource;

  scheduleDataArray = [];

  constructor(public fleetService: FleetService,
    private formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    public router: Router,
    private datePipe: DatePipe) {
    this.schedulefleetForm = formBuilder.group({
      'fleetLicenseNumber': [null, [
        Validators.required,
      ]],
      'startDateTime': [null, [
        Validators.required
      ]],
      'endDateTime': [null, [
        Validators.required
      ]],
      'unavailabilityReason': [null, [
        Validators.required
      ]]
    });
  }

  ngOnInit() {
    this.getAllFleets();
    this.getAllAvailabilityForAllFleets();
  }

  scheduleFleet(){
    console.log(this.schedulefleetForm.value);
    if(this.schedulefleetForm.value.startDateTime>this.schedulefleetForm.value.endDateTime){
      alert("Start date should be earlier than End date");
      return;
    }
    this.fleetService.addFleetAvailability(this.schedulefleetForm.value).subscribe(res => {
      console.log(this.schedulefleetForm.value);
      let newdata = this.schedulefleetForm.value;
      console.log(newdata);
      this.scheduleDataArray.push(newdata)
      this.scheduleDataSource.data = this.scheduleDataArray;
      console.log(this.scheduleDataArray);
    }, Error => {
      console.log(Error);
    });
  }

  getAllFleets() {
    //call get all fleet service here
    this.fleetService.getallFleets().subscribe(res => {
      console.log(res);
      for (let i = 0; i < res.length; i++) {

        this.vehicleNumberArray.push({
          vehicleLicenseNumber: res[i].vehicleLicenseNumber,
        })

        //console.log(this.vehicleNumberArray);
      }
    }, Error => {
      console.log(Error);
    });
  }

  getAllAvailabilityForAllFleets() {

     //call get all fleet service here
     this.fleetService.getAllAvailabilityForAllFleets().subscribe(res => {
      console.log(res);
      this.scheduleDataArray = res;      
      this.scheduleDataSource.data = this.scheduleDataArray;
    }, Error => {
      console.log(Error);
    });

  }
}
